import { render, staticRenderFns } from "./controlCabinet.vue?vue&type=template&id=39366fb8&scoped=true"
import script from "./controlCabinet.vue?vue&type=script&lang=js"
export * from "./controlCabinet.vue?vue&type=script&lang=js"
import style0 from "./controlCabinet.vue?vue&type=style&index=0&id=39366fb8&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39366fb8",
  null
  
)

export default component.exports